module.exports = __webpack_public_path__ + "img/software-dev.dba12507.jpg";